import styled from 'styled-components';
import { Typ20 } from 'dc/Typ';

type TipWrapperProps = {
  $showTip: boolean;
  $isBelow: boolean;
  $yPositioning: string;
  $xPositioning: string;
};

export const TipWrapper = styled.div<TipWrapperProps>`
  visibility: ${props => (props.$showTip ? 'visible' : 'hidden')};
  background: #9d2e58;
  border-radius: 2px;
  padding: 5px 12px;
  line-height: 0;
  width: 288px;
  position: absolute;
  z-index: 10;
  text-align: center;
  box-shadow:
    0px 1px 12px rgba(0, 0, 0, 0.16),
    0px 8px 24px rgba(0, 0, 0, 0.12);
  ${props =>
    props.$isBelow
      ? `bottom: ${props.$yPositioning};
      left: ${props.$xPositioning}`
      : `top: ${props.$yPositioning};
      right: ${props.$xPositioning}`};
`;

export const Text = styled(Typ20)`
  color: #fff;
`;

type PointerProps = {
  $isBelow: boolean;
};

export const Pointer = styled.div<PointerProps>`
  position: absolute;
  width: 0px;
  height: 0px;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  ${props =>
    props.$isBelow
      ? `border-bottom: 6px solid #9d2e58;
         top: -6px;
         left: 14px;`
      : `border-top: 6px solid #9d2e58;
         bottom: -6px;
         right: 14px;`};
`;

export const Container = styled.div`
  position: relative;
`;
